module.exports = ".content{display:flex;flex-direction:column}.ConfirmationDialog__Title{margin-top:0px}\n"